import {
  BusinessInfo as BusinessInfoProto,
  type BusinessProfile as BusinessProfileProto,
} from '@taxfyle/api-internal/internal/business_profile_pb'
import { Id } from '@/infra/id'
import { safeTimestampToDate } from '@/utils/grpc-util'
import { parseAmericanDate, dateFormatters } from '@/utils/date-util'
import { ContactInfo } from '@/features/jobs/info-gathering/ContactInfo'
import { mapContactInfoProtoToProps } from '@/features/jobs/info-gathering/contact-info-mappers'
import { BusinessInfo } from './BusinessInfo'
import type { BusinessProfileVersionProps } from './BusinessProfileVersion'

export function mapBusinessProfileVersionProtoToProps(
  proto: BusinessProfileProto,
): BusinessProfileVersionProps {
  const businessInfoProto = proto.getBusinessInfo()
  const contactInfoProto = proto.getContactInfo()

  return {
    id: Id(proto.getId()),
    version: proto.getVersion(),
    workspaceId: Id(proto.getWorkspaceId()),
    ownerUserId: Id(proto.getOwnerUserId()),
    createdAt: safeTimestampToDate(proto.getCreateTime()),
    updatedAt: safeTimestampToDate(proto.getUpdateTime()),
    businessInfo: businessInfoProto
      ? mapBusinessInfoProtoToProps(businessInfoProto)
      : BusinessInfo.empty,
    contactInfo: contactInfoProto
      ? mapContactInfoProtoToProps(contactInfoProto)
      : ContactInfo.empty,
  }
}

export function mapBusinessInfoProtoToProps(
  proto: BusinessInfoProto,
): BusinessInfo {
  const dateOfIncorporation = proto.getDateOfIncorporation()

  return {
    businessName: proto.getBusinessName(),
    dateOfIncorporation: dateOfIncorporation
      ? parseAmericanDate(dateOfIncorporation)
      : null,
    employerIdentificationNumber: proto.getEmployerIdentificationNumber(),
  }
}

export function mapBusinessInfoToProto(
  businessInfo: BusinessInfo,
): BusinessInfoProto {
  const proto = new BusinessInfoProto()
    .setBusinessName(businessInfo.businessName)
    .setEmployerIdentificationNumber(businessInfo.employerIdentificationNumber)

  if (businessInfo.dateOfIncorporation) {
    proto.setDateOfIncorporation(
      dateFormatters.dateAmerican.format(businessInfo.dateOfIncorporation),
    )
  }

  return proto
}
